module.exports = __webpack_public_path__ + "img/图3.d09b1c8b.jpg";